import React, { Component, useContext } from 'react';
import { Row, Col, Form, FormGroup, Label, Input } from 'reactstrap';
import styles from './VerifyInfo.module.css';
import SimpleReactValidator from 'simple-react-validator';
import { DropDownInput } from '../../../../components/inputs/DropDownInput';
import { DropDownAutoComplete } from '../../../../components/inputs/DropDownAutoComplete';
import CancelModal from '../../../../components/modals/CancelModal';
import SaveModal from '../../../../components/modals/SaveModal';
import classNames from 'classnames';
import DocumentTitle from 'react-document-title';
import SuggestedAddress from '../../../modals/SuggestedAddress';
import InvalidAddress from '../../../modals/InvalidAddress';
import { verifyAddress, VerificationResponseCodes, getLocationFromZip } from '../../../api/addressverification';
import PhoneNumberInput from '../../../shared/PhoneNumberUtility/PhoneNumberInput';
import { AddressForm, StaticAddress } from './CountryAddressForms';
import { UseTranslationInClassComponent } from '../../../contexts/LanguageTranslation/UseTranslationInClassComponent';
import { LanguageContext } from '../../../contexts/LanguageTranslation/LanguageContext';
import { ContractContext, BrandingContext } from '../../../contexts/ContractContext';
import IntakeLossButtons from './IntakeLossButtons';
import { parsePhoneNumber } from 'awesome-phonenumber';
import { ISOCountryCodes } from '../../../shared/PhoneNumberUtility/phoneUtils';
import { createOrUpdateClaimConfiguration } from '../../../../helpers';
import PageLoading from '../../../shared/PageLoading/PageLoading';
import { getEnvironment } from '../../../../helpers';
import { CombinedLangContractContext } from '../../../contexts/ProviderLangContractContext';
import ImageWithFallback from '../../../shared/ImageWithFallback/ImageWithFallback';
import getClientContent from '../../../_BrandingProvider/brandContent';

export default class VerifyInfo extends Component {
    constructor(props) {
        super(props);
        this.state = {
            clientId:
                typeof this.props.entitlementDetails === 'undefined'
                || this.props.entitlementDetails === null
                || typeof this.props.entitlementDetails.clientId === 'undefined'
                    ? 'apple'
                    : this.props.entitlementDetails.clientId,
            firstName: '',
            lastName: '',
            address1: '',
            address2: '',
            city: '',
            state: '',
            stateId: '',
            zip: '',
            contactPhone: '',
            email: '',
            states: null,
            cities: [],
            activeCountries: null,
            searching: false,
            claimNumber: this.props.entitlementDetails.claimNumber,
            claimId: this.props.entitlementDetails.claimId,
            caseNumber: this.props.entitlementDetails.caseNumber,
            pageTitle: `Shipping Info | ${getClientContent('apple')?.variableText?.pageTitle}`,
            showSuggestedAddressValidationModal: false,
            showInvalidAddressModal: false,
            verifiedAddress: null,
            addressToVerify: null,
            countryCode: this.props.entitlementDetails?.countryCode ?? 'us',
            shipToCountryCode:
                this.props.entitlementDetails?.shipToCountryCode ?? this.props.entitlementDetails?.countryCode,
            zipValidator: 'required|numeric|size:5',
            zipLength: 5,
            validationFired: false,
            isAppleWatch: false,
            disableCountryDropDown: false,
            watchDeviceOptions: [],
            selectedBand: '',
            bandColor: '',
            bandType: '',
            watchAccessories: '',
            fetchingWatchDetails: false,
            errorFetchingWatchDetails: false,
            isProduction: false
        };
        this.handleInputChange = this.handleInputChange.bind(this);
        this.keepOnPage = this.keepOnPage.bind(this);
        this.saveForLater = this.saveForLater.bind(this);
        this.validator = new SimpleReactValidator({
            messages: {
                phone: 'Please enter a valid phone number.',
                email: 'Please enter a valid email.',
                required: ':attribute is required.'
            },
            validators: {
                valid_phone: {
                    message: 'Please enter a valid phone number.',
                    rule: (val, params, validator) => {
                        return !new RegExp('^([0-9])\\1+$').test(val.match(/\d+/g).join(''));
                    }
                },
                pobox_check: {
                    message: 'Sorry, we are unable to ship to PO Boxes. Please update your shipping address.',
                    rule: (val, params, validator) => {
                        return (
                            validator.helpers.testRegex(
                                val,
                                /^(?![\d#]\ \w+)?^((?!^ *((^(?![\d#]).*p[ \.-/]*\ ?(o|0)[-. \/\\]*[\ \.\-]+[-]?((box|bin)|b|(#|num)?\d+))|(p(ost)? *(o(ff(ice)?)?)? +((box|bin)|b)? *\d+)|(p *-?\/?(o)? *-?box)|post office box)|(\bPOB\b)).)*$/gim
                            ) && params.indexOf(val) === -1
                        );
                    }
                },
                UKZipRegex: {
                    message: 'Please enter a valid postal code.',
                    rule: (val, params, validator) => {
                        return (
                            validator.helpers.testRegex(val, /^[a-zA-Z0-9]{2,4} [a-zA-Z0-9]{3}$/)
                            && params.indexOf(val) === -1
                        );
                    },
                    required: true
                }
            },
            element: (message) => (
                <div
                    className='errorMsg'
                    role='alert'
                >
                    {message.charAt(0).toUpperCase() + message.slice(1)}
                </div>
            )
        });
    }

    onSaveForLaterAction = (e) => {
        e.preventDefault();
        this.setState({ showConfirmation: true });
    };

    onSaveCancel = (e) => {
        e.preventDefault();
        this.setState({ showConfirmation: false });
    };

    componentWillMount() {
        const fetchEnvironment = async () => {
            const env = await getEnvironment();
            const envLower = await env.environment.toLowerCase();
            this.setState({
                isProduction: envLower === 'production'
            });
        };

        window.addEventListener('beforeunload', this.keepOnPage);
        fetchEnvironment();
    }

    handleInputChange = (e) => {
        let { name, value } = e.target;

        if (name === 'contactPhone') {
            // console.log("=== e.target ===", e.target.rawValue, e.target.phoneNumberModel)
            const { significant, input } = e.target.phoneNumberModel.number;
            value = significant || input;
        }

        if (name.includes('zip') && value.length >= 5) {
            getLocationFromZip(value, this.state.clientId, this.onZipVerified);
            this.setState({
                zipCode: value,
                zip: value
            });
        }

        this.setState({
            [name]: value
        });
    };

    onZipVerified = (result) => {
        if (result.successful) {
            var state = this.state.states.find(({ abbreviation }) => abbreviation === result.location.state);
            if (!state) return;
            this.setState({
                city: result.location.city,
                stateId: state.data,
                state: state.display
            });
        }
    };

    handleStateDropDown = (e) => {
        var state = this.state.states.find(({ data }) => data === e).display;
        this.setState({ stateId: e, state: state });
    };

    handleCityDropDown = (e) => {
        const city = this.state.cities?.find(({ data }) => data === e)?.display;
        this.setState({ city: city });
    };

    handleVerifyAddress = () => {
        this.setState({ validationFired: true });
        console.log(this.validator, this.state);

        if (this.validator.allValid()) {
            let shipState = this.state.stateId;
            let shipToCountry = this.state.shipToCountryCode ?? this.props.entitlementDetails?.countryCode;
            var stateInfo = this.state?.states?.filter(function (el) {
                return el.data === shipState;
            });

            let addressToVerify = {
                address1: this.state.address1,
                address2: this.state.address2,
                city: this.state.city,
                state: stateInfo?.length === 1 ? stateInfo[0]?.display : '',
                zip: this.state.zip,
                country: shipToCountry ?? 'us'
            };
            if (this.state.countryCode.toLowerCase() === 'cl') {
                addressToVerify.state = this.state.state;
            }

            this.setState({
                addressToVerify: addressToVerify
            });

            verifyAddress(addressToVerify, this.state.clientId, this.onAddressVerified);
        } else {
            this.validator.showMessages();
            this.forceUpdate();
        }
    };

    onAddressVerified = (result) => {
        //console.log(`LOG>> onAddressVerified: Result Code: ${result.code}`);

        if (result.code === VerificationResponseCodes.addressVerified) {
            this.setState(
                {
                    showSuggestedAddressValidationModal: false
                },
                () => this.continue()
            );
        } else if (result.code === VerificationResponseCodes.addressChanged) {
            this.setState({
                showSuggestedAddressValidationModal: true,
                verifiedAddress: result.returnedAddress
            });
        } else {
            this.setState({
                showInvalidAddressModal: true
            });
        }
    };

    onContinueSaveAction = (selectedAddress) => {
        if (selectedAddress === 'suggestedAddress') {
            let newAddress = this.state.verifiedAddress;
            let suggestedState;
            let stateId = null;
            let state = null;
            const suggestedZip =
                newAddress?.countryCode?.toLowerCase() === 'jp'
                    ? `${newAddress?.zip}${newAddress?.plus4 ? '-' + newAddress?.plus4 : ''}`
                    : newAddress?.zip;

            if (this.state.states.length) {
                suggestedState = this.state.states.find(
                    (st) =>
                        st.abbreviation === newAddress.stateAbbreviation || st.display === newAddress.stateAbbreviation
                );
                stateId = suggestedState ? suggestedState.data : null;
                state = suggestedState ? newAddress.stateAbbreviation : null;
            }

            if (this.state.countryCode.toLowerCase() === 'cl') {
                state = newAddress.stateAbbreviation;
                stateId = null;
            }

            this.setState(
                {
                    showSuggestedAddressValidationModal: false,
                    address1: `${newAddress.address1} ${newAddress.suite}`.trim(),
                    address2: newAddress.address2,
                    stateId: stateId,
                    state: state,
                    city: newAddress.city,
                    zip: suggestedZip
                },
                () => this.continue()
            );
        } else {
            this.setState(
                {
                    showSuggestedAddressValidationModal: false,
                    showInvalidAddressModal: false
                },
                () => this.continue()
            );
        }
    };

    onCloseAddressModal = () => {
        this.setState({
            showSuggestedAddressValidationModal: false,
            showInvalidAddressModal: false
        });
    };

    updateAddress = (partyAddress, entitlementDetails, type) => {
        let shipToCountryCode = this.state.shipToCountryCode ?? this.props.entitlementDetails?.countryCode;
        let countryId = this.state.activeCountries?.find(
            ({ countryCode }) => countryCode?.toLowerCase() === shipToCountryCode?.toLowerCase()
        )?.countryId;
        if (typeof partyAddress.find(({ addressTypeId }) => addressTypeId === type) != 'undefined') {
            partyAddress.find(({ addressTypeId }) => addressTypeId === type).address1 = this.state.address1;
            partyAddress.find(({ addressTypeId }) => addressTypeId === type).address2 = this.state.address2;
            partyAddress.find(({ addressTypeId }) => addressTypeId === type).city = this.state.city;
            partyAddress.find(({ addressTypeId }) => addressTypeId === type).state = this.state.state;
            partyAddress.find(({ addressTypeId }) => addressTypeId === type).stateId = this.state.stateId;
            partyAddress.find(({ addressTypeId }) => addressTypeId === type).zip = this.state.zip;
            partyAddress.find(({ addressTypeId }) => addressTypeId === type).countryId = countryId;
            partyAddress.find(({ addressTypeId }) => addressTypeId === type).countryCode = shipToCountryCode;
        } else {
            let newAddress = {
                addressTypeId: type,
                address1: this.state.address1,
                address2: this.state.address2,
                city: this.state.city,
                state: this.state.state,
                stateId: this.state.stateId,
                zip: this.state.zip,
                countryId: countryId,
                countryCode: shipToCountryCode
            };
            partyAddress.push(newAddress);
        }
    };

    continue = (e) => {
        this.setState({ searching: true });

        let updatedPhone =
            typeof this.props.entitlementDetails?.party?.partyPhoneModel[0] === 'undefined'
                ? ''
                : this.props.entitlementDetails?.party?.partyPhoneModel[0]?.number;
        let updatedEmail =
            typeof this.props.entitlementDetails?.party?.partyEmailModel[0] === 'undefined'
                ? ''
                : this.props.entitlementDetails?.party?.partyEmailModel[0]?.address;

        //update phone and email only when its valid for Save for Later
        if (this.validator.fieldValid('contactPhone')) {
            updatedPhone = this.state.contactPhone;
        }
        if (this.validator.fieldValid('email')) {
            updatedEmail = this.state.email;
        }

        const pn = parsePhoneNumber(updatedPhone, ISOCountryCodes[this.state.countryCode?.toUpperCase()] || 'us');
        let entitlementDetails = this.props.entitlementDetails;
        if (entitlementDetails.party.shippingAddress === null) {
            entitlementDetails.party.shippingAddress = {};
        }
        entitlementDetails.firstName = this.state.firstName;
        entitlementDetails.lastName = this.state.lastName;
        entitlementDetails.party.shippingAddress.address1 = this.state.address1;
        entitlementDetails.party.shippingAddress.address2 = this.state.address2;
        entitlementDetails.party.shippingAddress.city = this.state.city;
        entitlementDetails.party.shippingAddress.state = this.state.state;
        entitlementDetails.party.shippingAddress.zip = this.state.zip;
        entitlementDetails.party.shippingAddress.stateId = this.state.stateId;
        entitlementDetails.party.shippingAddress.countryCode = this.state.shipToCountryCode;
        entitlementDetails.contactPhone = pn.getNumber('significant');
        entitlementDetails.email = updatedEmail;
        entitlementDetails.clientId = this.state.clientId;

        let party = entitlementDetails.party;
        party.partyName = entitlementDetails.firstName + ' ' + entitlementDetails.lastName;
        party.firstName = entitlementDetails.firstName;
        party.lastName = entitlementDetails.lastName;

        let partyPhone = party.partyPhoneModel;
        console.log('=== partyPhone ===', partyPhone);
        let phoneNumber = partyPhone.find(({ phoneTypeId }) => phoneTypeId === 2);

        console.log('=== entitlementDetails.contactPhone ===', entitlementDetails.contactPhone);
        if (!(typeof phoneNumber === 'undefined' || phoneNumber === null)) {
            partyPhone.find(({ phoneTypeId }) => phoneTypeId === 2).number = entitlementDetails.contactPhone;
        } else {
            // Add new element to array
            var newPhone = {
                partyId: party.partId,
                phoneTypeId: 2,
                number: entitlementDetails.contactPhone,
                IsPrimary: true
            };
            partyPhone.push(newPhone);
        }

        party.partyPhoneModel = partyPhone;

        let partyEmail = party.partyEmailModel;
        if (partyEmail.length) {
            partyEmail[0].address = entitlementDetails.email;
        } else {
            // Add new element to array
            var newEmail = { partyId: party.partId, address: entitlementDetails.email, IsPrimary: true };
            partyEmail.push(newEmail);
        }

        party.partyEmailModel = partyEmail;

        let partyAddress = party.partyAddressModel;
        const partyMailingAddress = partyAddress.find(({ addressTypeId }) => addressTypeId === 2);
        if (
            partyMailingAddress.address1 === null
            || partyMailingAddress.address1 === undefined
            || partyMailingAddress.address1 === ''
        ) {
            this.updateAddress(partyAddress, entitlementDetails, 1);
            this.updateAddress(partyAddress, entitlementDetails, 2);
        }

        if (
            party.serviceAddress.address1 === null
            || party.serviceAddress.address1 === undefined
            || party.serviceAddress.address1 === ''
        ) {
            entitlementDetails.party.serviceAddress = { ...entitlementDetails.party.shippingAddress };
            entitlementDetails.party.billingAddress = { ...entitlementDetails.party.shippingAddress };
        }

        this.updateAddress(partyAddress, entitlementDetails, 3);

        party.partyAddressModel = partyAddress;
        console.log(party, partyAddress, partyEmail, partyPhone, entitlementDetails, this.state.clientId);

        entitlementDetails.shippingAddress = partyAddress.find((p) => p.addressTypeId == 3); // 3- shipping Address Type

        let shipToCountryCode = this.state.shipToCountryCode ?? this.props.entitlementDetails?.countryCode;

        if (this.state.isAppleWatch && !this.state.errorFetchingWatchDetails) {
            //Update Claim configuration for watch accessories
            createOrUpdateClaimConfiguration(this.state.claimId, 40, this.state.watchAccessories, this.state.clientId);
            //Update Claim configuration for watch partNumber
            createOrUpdateClaimConfiguration(this.state.claimId, 41, this.state.selectedBand, this.state.clientId);
        } else if (this.state.isAppleWatch && this.state.errorFetchingWatchDetails) {
            //For errors fetching watch details, don't save band details update claim configuration to add for run-off
            createOrUpdateClaimConfiguration(this.state.claimId, 50, 'true', this.state.clientId);
        }

        if (!(typeof shipToCountryCode === 'undefined' || shipToCountryCode === null)) {
            entitlementDetails.shipToCountryCode = shipToCountryCode?.toLowerCase();
            //Save the Ship to country code in Claim Configuration
            createOrUpdateClaimConfiguration(
                this.state.claimId,
                25,
                shipToCountryCode?.toLowerCase(),
                this.state.clientId
            );
            // Save the Ship to country code
            fetch(`api/Contract/SaveContractConfiguration/${this.state.clientId}`, {
                method: 'post',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                    contractId: this.props.entitlementDetails.contract.contractId,
                    contractAttributeId: 32, // ship-to Country code
                    value: shipToCountryCode?.toLowerCase()
                })
            }).then((res) => {
                if (res.ok) {
                    if (res.status === '204') {
                        res.json().then((data) => {
                            console.log(data);
                        });
                    }
                } else {
                    console.log(res);
                }
            });
        }

        if (
            this.props.entitlementDetails.countryCode !== null
            && this.props.entitlementDetails?.countryCode?.toLowerCase() !== shipToCountryCode?.toLowerCase()
        ) {
            //Update Cross Border Claim Configuration
            createOrUpdateClaimConfiguration(this.state.claimId, 33, true, this.state.clientId);
        }

        fetch('api/party/'.concat(this.props.entitlementDetails.party.partyId, '/').concat(this.state.clientId), {
            method: 'put',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                partyId: this.props.entitlementDetails.party.partyId,
                firstName: this.state.firstName,
                lastName: this.state.lastName,
                partyName: this.state.firstName + ' ' + this.state.lastName,
                partyAddressModel: partyAddress,
                partyPhoneModel: partyPhone,
                partyEmailModel: partyEmail,
                contractPartyId: this.props.entitlementDetails.contract.party.partyId,
                IsVerifyInfoUpdate: true
            })
        })
            .then((res) => {
                if (res.ok) {
                    if (res.status === 200) {
                        res.json().then((data) => {
                            this.setState((prev) => {
                                return {
                                    party: data,
                                    editing: !prev.editing,
                                    saving: !prev.saving
                                };
                            });
                        });

                        if (this.state.isSaveForLater) {
                            this.saveForLaterAction(this.props.history.location.state.claim, false);
                            return;
                        }

                        this.props.history.push('/vendor/apple/payment', {
                            entitlementDetails: entitlementDetails,
                            claim: this.props.history.location.state.claim,
                            watchAccessories: this.state.watchAccessories,
                            selectedBand: this.state.selectedBand,
                            bandColor: this.state.bandColor,
                            bandType: this.state.bandType
                        });

                        this.setState({ searching: false });
                    } else {
                        this.setState({ searching: false });
                        this.props.history.push('/vendor/apple/error', {
                            entitlementDetails: entitlementDetails,
                            claim: this.props.history.location.state.claim,
                            path: window.location.pathname?.toLowerCase(), // Depends on step in FNOL flow
                            isFNOLSystemError: true
                        });
                    }
                } else {
                    this.setState({ searching: false });
                    this.props.history.push('/vendor/apple/error', {
                        entitlementDetails: entitlementDetails,
                        claim: this.props.history.location.state.claim,
                        path: window.location.pathname?.toLowerCase(), // Depends on step in FNOL flow
                        isFNOLSystemError: true
                    });
                }
            })
            .catch((error) => {
                console.log(error);
            });
    };

    componentDidMount(prevProps) {
        const { history } = this.props;
        //Key = 2 needed to access variable of '2' found in the assetConfigDictionary
        const configDescriptionKey = '2';
        const contractAsset = this.props?.entitlementDetails?.contract?.contractAssetModel?.filter(
            (cam) => cam.contractAssetId === this.props?.entitlementDetails?.contractAsset?.contractAssetId
        )[0];
        const deviceDescription = contractAsset?.assetConfigDictionary[configDescriptionKey];
        if (deviceDescription?.toLowerCase()?.includes('watch') || deviceDescription?.toLowerCase()?.includes('ipad')) {
            this.setState({ disableCountryDropDown: true });
        }
        //Triggers if device type is watch; Triggers watch UI
        if (deviceDescription?.toLowerCase()?.includes('watch')) {
            this.setState({ isAppleWatch: true, fetchingWatchDetails: true });
            fetch(
                'vendor/apple/watch/bands/'
                    + contractAsset?.contractAssetId
                    + '/'
                    + contractAsset?.serialNumber
                    + '/'
                    + this.state.countryCode
                    + '/'
                    + this.state.clientId,
                {
                    method: 'Get',
                    headers: {
                        'Content-Type': 'application/json'
                    }
                }
            ).then((res) => {
                if (res.ok) {
                    if (res.status === 200) {
                        res.json().then((data) => {
                            this.setState({
                                watchDeviceOptions: data,
                                fetchingWatchDetails: false,
                                errorFetchingWatchDetails: false
                            });
                        });
                    } else {
                        let errorWatchDeviceOptions = [
                            {
                                color: 'Black',
                                bandType: 'Sport Band',
                                partNumber: 'ErrorBand'
                            }
                        ];

                        this.setState({
                            watchDeviceOptions: errorWatchDeviceOptions,
                            errorFetchingWatchDetails: true,
                            fetchingWatchDetails: false
                        });
                    }
                } else {
                    let errorWatchDeviceOptions = [
                        {
                            color: 'Black',
                            bandType: 'Sport Band',
                            partNumber: 'ErrorBand'
                        }
                    ];

                    this.setState({
                        watchDeviceOptions: errorWatchDeviceOptions,
                        errorFetchingWatchDetails: true,
                        fetchingWatchDetails: false
                    });
                }
            });
        }

        if (history?.location?.pathname === '/vendor/apple/verifyinfo') {
            window.history.pushState(this.props.history?.location, document.title, window.location.href);
            window.scrollTo(0, 0);
        }
        let isFromPayment = this.props.history?.location?.state?.fromPayment;

        let countryCode = isFromPayment
            ? this.props.entitlementDetails.party.shippingAddress.countryCode
            : this.props.entitlementDetails.party?.serviceAddress?.countryCode
              || this.props.entitlementDetails?.countryCode
              || 'us';
        let zipLength = 5;
        let zipValidator = 'required| numeric | size:5';

        switch (countryCode) {
            case 'aus':
                zipLength = 4;
                zipValidator = 'required|numeric|size:4';
                break;
            case 'uk':
                zipLength = 8;
                zipValidator = 'required|size:8';
                break;
            default:
                zipLength = 5;
                zipValidator = 'required|numeric|size:5';
                break;
        }

        fetch('api/party/states/' + countryCode + '/' + this.state.clientId)
            .then((res) => res.json())
            .then((data) => {
                this.setState({
                    states: data.map((s) => {
                        return {
                            data: s.stateId,
                            display: s.name,
                            abbreviation: s.abbreviation
                        };
                    })
                });
            });

        fetch('api/party/activecountries/' + this.state.clientId)
            .then((res) => res.json())
            .then((data) => {
                this.setState({
                    activeCountries: data.map((s) => {
                        return {
                            countryId: s.countryId,
                            countryCode: s.iso2 == 'AU' ? 'AUS' : s.iso2 == 'GB' ? 'UK' : s.iso2,
                            countryName: s.countryName
                        };
                    })
                });
            });

        if (isFromPayment) {
            //Pre-populate customer inputted data only when returning from the payment page: SEU-45067
            let shipAddress = this.props.entitlementDetails?.party?.shippingAddress;

            this.setState({
                firstName: this.props.entitlementDetails?.firstName,
                lastName: this.props.entitlementDetails?.lastName,
                address1: shipAddress?.address1,
                address2: shipAddress?.address2,
                city: shipAddress?.city,
                state: shipAddress?.state,
                stateId: shipAddress?.stateId,
                zip: shipAddress?.zip,
                contactPhone: this.props.entitlementDetails?.contactPhone,
                email: this.props.entitlementDetails?.email
            });
        }

        if (
            isFromPayment
            && this.props?.entitlementDetails?.contract?.contractAssetModel[0]?.assetConfigDictionary[
                configDescriptionKey
            ]
                ?.toLowerCase()
                ?.includes('watch')
        ) {
            this.setState({
                selectedBand: this.props.history?.location?.state?.selectedBand,
                bandColor: this.props.history?.location?.state?.bandColor,
                bandType: this.props.history?.location?.state?.bandType,
                watchAccessories: this.props.history?.location?.state?.bandType
            });
        }

        window.addEventListener('beforeunload', this.keepOnPage);
    }

    componentWillUnmount() {
        window.removeEventListener('beforeunload', this.keepOnPage);
    }

    saveForLater = (e) => {
        e && e.preventDefault();
        this.setState({ isSaveForLater: true }, () => {
            this.continue();
        });
    };

    saveForLaterAction = (claim, claimAbandoned) => {
        if (!claim) {
            return;
        }
        this.setState({ uploading: true });
        console.log(this.props, claim);
        const entitlementDetails = this.props.entitlementDetails;
        const partyModel = entitlementDetails?.party;
        const model = {
            claimModel: claim,
            partyModel: null
        };
        fetch(`api/claim/SaveForLater/${claim.claimId}/2/${claimAbandoned}/apple`, {
            method: 'post',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(model)
        }).then((data) => {
            if (data.status === 204) {
            }
            if (data.status === 200 && !claimAbandoned) {
                this.props.history.push('/vendor/apple/confirmation', {
                    statusType: 'savedClaim',
                    caseNumber: claim.clientClaimNumber,
                    claimEmail: this.state.email
                });
            }
            this.setState({ uploading: false });
        });
    };

    handleChangeShipToCountry = (states, shipToCountryCode) => {
        if (
            shipToCountryCode?.toLowerCase()
            === this.props.entitlementDetails?.party?.serviceAddress?.countryCode?.toLowerCase()
        ) {
            this.setState({
                states: states,
                shipToCountryCode: shipToCountryCode?.toLowerCase(),
                state: this.props.entitlementDetails?.party?.serviceAddress?.state || '',
                stateId: this.props.entitlementDetails?.party?.serviceAddress?.stateId || ''
            });
        } else {
            this.setState({
                states: states,
                shipToCountryCode: shipToCountryCode?.toLowerCase(),
                stateId: null,
                state: ''
            });
        }
    };

    handleUpdateToLocalCities = (cities, shipToStateId) => {
        if (shipToStateId === this.props.entitlementDetails?.party?.serviceAddress?.stateId) {
            this.setState({
                cities: cities,
                city: this.props.entitlementDetails?.party?.serviceAddress?.city || ''
            });
        } else {
            this.setState({
                cities: cities,
                city: ''
            });
        }
    };

    keepOnPage(e) {
        // Cancel the event as stated by the standard.
        e.preventDefault();
        // Chrome requires returnValue to be set.
        e.returnValue = '';

        this.saveForLaterAction(this.props.history.location.state.claim, true);
    }

    render() {
        //const testingCountry = 'us' // change the countries fo testing
        const { pageTitle } = this.state;
        const {
            data: { isChileApple }
        } = this.context.contractContext;
        let isFromPayment = this.props.history?.location?.state?.fromPayment;
        const phoneMinLength = this.context?.languageContext?.countryVars?.phone?.minInputLength ?? 6;

        return (
            <UseTranslationInClassComponent
                componentPathFromSrcFolder={'components/Vendor/Apple/IntakeLoss/VerifyInfo'}
            >
                {(international) => {
                    const { country, translations } = international;
                    return (
                        <DocumentTitle title={pageTitle}>
                            <>
                                <Form>
                                    <fieldset>
                                        {this.state.isAppleWatch && (
                                            <>
                                                <FormGroup
                                                    className={
                                                        !this.state.selectedBand
                                                        && this.state.validationFired
                                                        && styles.formError
                                                    }
                                                >
                                                    <h1>
                                                        {translations?.selectWatchBandTitle || 'Select Your Watch Band'}
                                                    </h1>
                                                    <p
                                                        className={classNames(
                                                            'cardTitle mb-4',
                                                            !this.state.selectedBand
                                                                && this.state.validationFired
                                                                && styles.formError
                                                        )}
                                                        id='reach-skip-nav'
                                                    >
                                                        {translations?.selectWatchBandP1
                                                            || 'Please select a watch band to receive with your replacement device.'}
                                                        <span
                                                            aria-hidden='true'
                                                            className='required-indicator'
                                                        >
                                                            *
                                                        </span>
                                                    </p>
                                                    <Row className={styles.watchBandContainer}>
                                                        {!this.state.fetchingWatchDetails
                                                            && this.state.watchDeviceOptions.map((opt) => {
                                                                return (
                                                                    <div
                                                                        className={classNames(
                                                                            styles.radioCustomBg,
                                                                            'radioButton customRadio mr-3'
                                                                        )}
                                                                        role='radio'
                                                                        aria-checked={
                                                                            this.state.selectedBand === opt?.partNumber
                                                                                ? 'true'
                                                                                : 'false'
                                                                        }
                                                                        tabIndex='0'
                                                                        id='reach-skip-nav'
                                                                    >
                                                                        <Input
                                                                            type='radio'
                                                                            name={'watch' + opt?.partNumber}
                                                                            id={opt?.partNumber}
                                                                            value={opt?.partNumber}
                                                                            onKeyPress={this.handleKeyDown}
                                                                            checked={
                                                                                this.state.selectedBand
                                                                                === opt?.partNumber
                                                                            }
                                                                            onChange={() =>
                                                                                this.setState({
                                                                                    selectedBand: opt?.partNumber,
                                                                                    bandColor: opt?.color,
                                                                                    bandType: opt?.bandType,
                                                                                    watchAccessories: `${opt?.color}, ${opt?.bandType}`
                                                                                })
                                                                            }
                                                                        />
                                                                        <Label
                                                                            id={`part: ${opt?.partNumber}`}
                                                                            className={classNames(
                                                                                styles.watchButton,
                                                                                'radio-controls-label',
                                                                                !this.state.selectedBand
                                                                                    && this.state.validationFired
                                                                                    && styles.formError
                                                                            )}
                                                                            for={opt?.partNumber}
                                                                        >
                                                                            <div className={styles.watchColor}>
                                                                                {opt?.color}
                                                                            </div>
                                                                            <div className={styles.watchBand}>
                                                                                {opt?.bandType}
                                                                            </div>
                                                                            {this.state.isProduction
                                                                            && !this.state.errorFetchingWatchDetails ? (
                                                                                <ImageWithFallback
                                                                                    src={`${opt?.imageUrl}`}
                                                                                    customClass={styles.bandImage}
                                                                                    isUrlImage={true}
                                                                                />
                                                                            ) : (
                                                                                <ImageWithFallback
                                                                                    src={`${opt?.partNumber}.gif`}
                                                                                    customClass={styles.bandImage}
                                                                                />
                                                                            )}
                                                                        </Label>
                                                                    </div>
                                                                );
                                                            })}
                                                        {this.state.fetchingWatchDetails && (
                                                            <PageLoading
                                                                text={''}
                                                                height={250}
                                                            />
                                                        )}
                                                    </Row>
                                                    {this.validator.message(
                                                        'watchBand',
                                                        this.state.selectedBand,
                                                        'required',
                                                        {
                                                            messages: {
                                                                required:
                                                                    translations.errors?.contactPhoneRequired
                                                                    || 'Watch band selection is required.'
                                                            }
                                                        }
                                                    )}
                                                </FormGroup>
                                            </>
                                        )}
                                        <h1>{translations?.title || 'Verify Your Shipping Details'}</h1>
                                        <p
                                            className='cardTitle mb-4'
                                            id='reach-skip-nav'
                                        >
                                            {translations.whereTo
                                                || 'Where would you like your replacement device sent?'}{' '}
                                            <span
                                                aria-hidden='true'
                                                className='required-indicator'
                                            >
                                                *
                                            </span>
                                        </p>
                                        <Col
                                            md='8'
                                            id='shippingAddressFields'
                                            className='p-0 mb-3'
                                        >
                                            <AddressForm
                                                allowVariableCountry
                                                onUpdateStates={this.handleChangeShipToCountry}
                                                onUpdateCities={this.handleUpdateToLocalCities}
                                                clientId={this.state.clientId}
                                                includeNameFields
                                                address={{
                                                    firstName: this.state.firstName,
                                                    lastName: this.state.lastName,
                                                    address1: this.state.address1,
                                                    address2: this.state.address2,
                                                    city: this.state.city,
                                                    zip: this.state.zip,
                                                    state: this.state.state,
                                                    stateId: this.state.stateId,
                                                    country: isFromPayment
                                                        ? this.props.entitlementDetails.party?.shippingAddress
                                                              ?.countryCode
                                                        : this.props.entitlementDetails.party?.serviceAddress
                                                              ?.countryCode
                                                          || this.props.entitlementDetails?.countryCode
                                                          || 'us'
                                                }}
                                                states={this.state.states}
                                                cities={this.state.cities}
                                                handleInputChange={this.handleInputChange}
                                                handleStateDropDown={this.handleStateDropDown}
                                                handleCityDropDown={this.handleCityDropDown}
                                                validator={this.validator}
                                                validationFired={this.state.validationFired}
                                                countryCode={this.state.shipToCountryCode}
                                                isChileApple={isChileApple}
                                                disableCountryDropDown={this.state.disableCountryDropDown}
                                            />
                                        </Col>
                                    </fieldset>
                                    <fieldset>
                                        <legend className='cardTitle mb-4'>
                                            {translations.provideInfo
                                                || 'We will reach you at the below provided contact details regarding your claim:'}
                                        </legend>
                                        <Col
                                            md='8'
                                            id='contactInformation'
                                            className='p-0'
                                        >
                                            <PhoneNumberInput
                                                fieldName='contactPhone'
                                                label={translations.contactPhone || 'Contact Phone'}
                                                value={this.state.contactPhone}
                                                onChange={this.handleInputChange}
                                                validationFired={this.state.validationFired}
                                                error={this.validator.message(
                                                    'contactPhone',
                                                    this.state.contactPhone,
                                                    `required|valid_phone|${country === 'US' ? '|phone' : ''}|min:${phoneMinLength}`,
                                                    {
                                                        messages: {
                                                            required:
                                                                translations.errors?.contactPhoneRequired
                                                                || 'Contact phone is required.',
                                                            phone:
                                                                translations.errors?.contactPhoneInvalid
                                                                || 'The phone number must be a valid number.',
                                                            valid_phone:
                                                                translations.errors?.contactPhoneInvalid
                                                                || 'The phone number must be a valid number.',
                                                            min:
                                                                translations.errors?.contactPhoneInvalid
                                                                || 'The phone number must be a valid number.'
                                                        }
                                                    }
                                                )}
                                            />

                                            <FormGroup
                                                className={classNames(
                                                    this.state.validationFired
                                                        && this.validator.message(
                                                            'email',
                                                            this.state.email,
                                                            'required|email'
                                                        )
                                                        && 'form-error'
                                                )}
                                            >
                                                <Label
                                                    for='emailAddress'
                                                    className='form-label'
                                                >
                                                    {translations.email || 'Email Address'}
                                                </Label>
                                                <span
                                                    aria-hidden='true'
                                                    className='required-indicator'
                                                >
                                                    *
                                                </span>
                                                <Input
                                                    className='form-control'
                                                    autoComplete='email'
                                                    id='emailAddress'
                                                    type='email'
                                                    name='email'
                                                    onChange={this.handleInputChange}
                                                    value={this.state.email}
                                                    aria-required='true'
                                                />
                                                {this.validator.message('email', this.state.email, 'required|email', {
                                                    messages: {
                                                        required:
                                                            translations.errors?.emailRequired || 'Email is required.',
                                                        email:
                                                            translations.errors?.emailInvalid
                                                            || 'The email must be a valid email address.'
                                                    }
                                                })}
                                            </FormGroup>
                                        </Col>
                                    </fieldset>
                                </Form>
                                <Row>
                                    <IntakeLossButtons
                                        // PRIMARY BUTTON PROPS
                                        buttonText={translations.continue || 'Continue'}
                                        onButtonClick={this.handleVerifyAddress}
                                        buttonDisabled={this.state.searching}
                                        buttonSpinning={this.state.searching}
                                        buttonAriaLabel={
                                            translations.continueBtnAria
                                            || 'Click continue to proceed to pay deductible step'
                                        }
                                        // FIRST LINK UNDER BUTTON
                                        showLink1={true}
                                        onLink1Click={this.onSaveForLaterAction}
                                        link1AriaLabel={translations.saveBtnAria || 'Opens a modal to save your claim'}
                                        link1Text={translations.save || 'Save For Later'}
                                        // CANCEL LINK PROPS CONTROL CANCEL MODAL
                                        saveClaimClickActionFromWithinCancelModal={this.onSaveForLaterAction}
                                        caseNumberToCancel={this.state.caseNumber}
                                        claimNumberToCancel={this.state.claimNumber}
                                    />
                                    {this.state.showConfirmation && (
                                        <SaveModal
                                            isOpen={this.state.showConfirmation}
                                            showConfirmation={this.state.showConfirmation}
                                            history={this.props.history}
                                            continuing={this.state.isSaveForLater}
                                            onCancel={this.onSaveCancel}
                                            onSaveForLaterAction={this.saveForLater}
                                            client={'apple'}
                                        />
                                    )}
                                </Row>
                                {this.state.showSuggestedAddressValidationModal && (
                                    <SuggestedAddress
                                        showSuggestedAddressValidationModal={
                                            this.state.showSuggestedAddressValidationModal
                                        }
                                        enteredAddress={this.state.addressToVerify}
                                        suggestedAddress={this.state.verifiedAddress}
                                        onContinueAction={this.onContinueSaveAction}
                                        onEditAddress={this.onCloseAddressModal}
                                        clientId={this.state.clientId}
                                    />
                                )}

                                {this.state.showInvalidAddressModal && (
                                    <InvalidAddress
                                        showInvalidAddressModal={this.state.showInvalidAddressModal}
                                        onEditAddress={this.onCloseAddressModal}
                                        onContinueAction={this.onContinueSaveAction}
                                    />
                                )}
                            </>
                        </DocumentTitle>
                    );
                }}
            </UseTranslationInClassComponent>
        );
    }
}

VerifyInfo.contextType = CombinedLangContractContext;
